import * as HttpService from "../../../../service/HttpService";


/**
 * 获取用电单位下拉列表
 */
export const gteElectricityUnit = () => {
    return HttpService.post(HttpService.DOMAIN + "/defectiveWorkOrder/gteElectricityUnit","");
};

export const gteElectricity = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/defectiveWorkOrder/gteElectricity",data);
};

/**
 * 获取设备树信息
 */
export const getDeviceTree = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/defectiveWorkOrder/getDeviceTree",data);
};


/**
 * 获取人员树
 */
export const getPeopleTree = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/defectiveWorkOrder/getPeopleTree",data);
};

/**
 * 新增工单
 */
export const addDefectWorkOrder = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/energyRushRepairSheet/addWorkOrder",data);
};

/**
 * 获取工单列表
 */
export const getWorkOrder = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/energyRushRepairSheet/getWorkOrder",data);
};

/**
 * 删除工单
 */
export const deleteElectricity = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/energyRushRepairSheet/deleteElectricity",data);
};

/**
 * 新增处理信息
 */
export const handleElectricity = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/energyRushRepairSheet/handleElectricity",data);
};

/**
 * 新增验收信息
 */
export const examineElectricity = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/energyRushRepairSheet/examineElectricity",data);
};


/**
 * 更新工单
 */
export const editEfectWorkOrder = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/energyRushRepairSheet/editEfectWorkOrder",data);
};









